import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { FunctionComponent, ReactNode } from "react";

interface Props {
  header: string;
  children: ReactNode;
}

const PageLayout: FunctionComponent<Props> = (props: Props): JSX.Element => {
  const { header, children } = props;

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack padding={isSmallScreen ? 1 : 2} spacing={4}>
      {!isSmallScreen && <Typography variant="h5">{header}</Typography>}
      <Box>{children}</Box>
    </Stack>
  );
};

export default PageLayout;
